import { makeStyles } from '@mui/styles'
import Link from 'next/link'
import { useRouter } from 'next/router'
// import { Markup } from 'interweave'
import { Markup } from 'react-render-markup'

import { Typography } from '@mui/material'
import { usePost, usePosts } from '../../hooks/useAdmin'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    color: theme.palette.secondary.main,
    marginBottom: '20px',
  },

  containerText: {
    padding: '50px 20rem',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center !important',
    alignItems: 'center !important',

    [theme.breakpoints.down('sm')]: {
      padding: '0 2rem',
    },

    '& h1': {
      fontSize: '35px',
      fontWeight: 'bold',
      textAlign: 'center',
    },

    '& h2': {
      fontSize: '22px',
      fontWeight: 'bold',
    },

    '& h2.ql-align-justify': {
      textAlign: 'justify',
      margin: '80px 0 0 0',
      padding: 0,
    },

    '& .ql-align-justify': {
      fontSize: 18,
      textAlign: 'justify',
    },

    '& p.ql-align-center': {
      textAlign: 'center',
    },
  },
  contentBlog: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    lineHeight: ({ category }: any) => category === 15 && '1em',
  },
  title: {
    color: theme.palette.secondary.main,
    textTransform: 'capitalize',
    fontSize: '35px',
    fontWeight: 'bold',
    width: '100%',
    textAlign: 'center',
  },
  post: {
    cursor: 'pointer',
  },
  postImage: {
    borderRadius: 3,
    '&:hover': {
      transition: '.5s',
      scale: 1.02,
    },
  },
  relatedPosts: {
    gap: 20,
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
}))

export const BlogPostContainer = () => {
  const { data: posts } = usePosts({})
  const router = useRouter()
  const { query } = router
  const { data: post } = usePost(query.post as string)

  const classes = useStyles({ category: post?.category?.id })

  const getRelatedPosts = () => {
    if (posts?.results && post) {
      const postsFiltered = post && posts?.results.filter((p) => p.category.slug === post.category.slug)
      return postsFiltered.slice(1, 4)
    }
    return []
  }

  const formatContent = () =>
    post?.content.split('<p class="ql-align-center"><br></p>')
      .join('')
      .split('<p class="ql-align-justify"><br></p>')
      .join('')

  return (
    <div className={classes.container}>
      <div
        className={classes.containerText}
      >
        <Typography variant="h1">{post?.title}</Typography>
        <Markup
          markup={formatContent()}
          className={post?.category?.id === 15 && classes.contentBlog}
        />
      </div>
      <h2 className={classes.title}>publicaciones relacionadas</h2>
      <div className={classes.relatedPosts}>
        {getRelatedPosts()
          .map((post) => (
            <Link href={post?.slug} passHref>
              <div className={classes.post}>
                <img className={classes.postImage} width={350} height={300} src={post.coverPage} alt={post.title} />
                <p style={{
                  textAlign: 'center',
                  width: 350,
                  fontSize: 20,
                  fontWeight: 600,
                  marginTop: -2,
                }}
                >
                  {post.title}
                </p>
              </div>
            </Link>
          ))}
      </div>
    </div>
  )
}
